import { Fab, Tooltip } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { useTranslation } from "react-i18next";

const ChatButton = ({ onClick }) => {
  const { t } = useTranslation("chat");

  return (
    <Tooltip title={t("openChat")} placement="left">
      <Fab
        color="primary"
        onClick={onClick}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1400,
        }}
      >
        <ChatIcon />
      </Fab>
    </Tooltip>
  );
};

export default ChatButton;
